module.exports = __webpack_public_path__ + "static/media/oberflex-black.f15dfa19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/oberflex-black.svg
// module id = 328
// module chunks = 37